import React, { FC, ReactElement } from 'react';
import './style.scss';

interface Props {
  middle: ReactElement | null;
  styleDef?: React.CSSProperties;
}

const MiddleLayoutContent: FC<Props> = ({ middle, styleDef }) => {
  return (
    <div className="_middle_container">
      <div className="_layout">
        <div className="_box">
          <div className="_content_box scroll_style" style={styleDef}>
            {middle}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiddleLayoutContent;
